import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
  emailStored: null,
  appStatus: null,
  contactStored: null,
  gstn: null,
  gstname: null,
  checkoboxCheck: "",
  token: null,
};

const emailSlice = createSlice({
  name: "EmailData",
  initialState: initialState,
  reducers: {
    emailAction: (state, action) => {
      state.emailStored = action.payload;
    },
    appAction: (state, action) => {
      state.appStatus = action.payload;
    },
    contactAction: (state, action) => {
      state.contactStored = action.payload;
    },
    gstnAction: (state, action) => {
      state.gstn = action.payload;
    },
    gstnameAction: (state, action) => {
      state.gstname = action.payload;
    },
    checkBoxAction: (state, action) => {
      state.checkoboxCheck = action.payload;
    },
    tokenAction: (state, action) => {
      state.token = action.payload;
    },
  },
});

export const {
  emailAction,
  appAction,
  contactAction,
  gstnAction,
  gstnameAction,
  checkBoxAction,
  tokenAction,
} = emailSlice.actions;
// export const resetState = () => ({
//   type: "mySlice/resetState",
// });
export const EmailReducer = emailSlice.reducer;
